import {
  AppBar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { logo } from "../../assets/images";
import CustomButton from "../CustomButton";

const NavBar = () => {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const navLinks = [
    {
      id: "home",
      label: "Home",
      link: "/",
    },
    {
      id: "about",
      label: "About",
      link: "/about",
    },
    {
      id: "sites",
      label: "Sites",
      link: "/sites",
    },
    {
      id: "news",
      label: "News",
      link: "/news",
    },
    {
      id: "faq",
      label: "FAQ",
      link: "/faq",
    },
  ];

  const mobileNavLinks = [
    {
      id: "home",
      label: "Home",
      link: "/",
    },
    {
      id: "about",
      label: "About",
      link: "/about",
    },
    {
      id: "sites",
      label: "Sites",
      link: "/sites",
    },
    {
      id: "news",
      label: "News",
      link: "/news",
    },
    {
      id: "faq",
      label: "FAQ",
      link: "/faq",
    },
    {
      id: "donate",
      label: "Journey with us",
      link: "/donate",
    },
  ];

  const handleCloseNavMenu = (nav) => {
    navigate(nav.link);
    setAnchorElNav(null);
  };

  const [bgColor, setBgColor] = useState("rgba(255, 255, 255,1)");

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setBgColor("rgba(255, 255, 255, 0.9)");
      } else {
        setBgColor("rgba(255, 255, 255, 0.9)");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <AppBar
      position="fixed"
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        py: 1.5,
        backgroundColor: bgColor,
        transition: "background-color 0.3s ease-in-out",
      }}
    >
      <Toolbar sx={{ /* bgcolor: "blue", */ width: "100%" }}>
        <Box
          sx={{ height: "50px", width: "50px", mx: 2, cursor: "pointer" }}
          onClick={handleOpenNavMenu}
        >
          <img src={logo} alt="" width={"50px"} />
        </Box>
        <Typography
          variant="h6"
          color="primary"
          sx={{
            fontWeight: "600",
            textTransform: "uppercase",
            display: { xs: "block", md: "block" },
            fontSize: { xs: "16px" },
          }}
        >
          EAGLE Learning
        </Typography>
        <Menu
          anchorEl={anchorElNav}
          open={Boolean(anchorElNav)}
          onClose={() => setAnchorElNav(null)}
          sx={{ display: { xs: "flex", md: "none" } }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {mobileNavLinks.map((nav) => (
            <MenuItem
              key={nav}
              onClick={() => handleCloseNavMenu(nav)}
              sx={{ my: 2, display: "flex", justifyContent: "center" }}
            >
              {nav.label}
            </MenuItem>
          ))}
          <CustomButton
            onClick={() => navigate("/donate")}
            sx={{ display: { xs: "none", md: "flex" }, ml: 6 }}
          >
            Journey with us
          </CustomButton>
        </Menu>
        <Box
          sx={{
            flexGrow: 1,
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          {navLinks.map((nav) => (
            <Typography
              key={nav.id}
              onClick={() => navigate(nav.link)}
              sx={{
                my: 2,
                mx: 4,
                color: "secondary.main",
                display: "block",
                cursor: "pointer",
                fontSize: "15px",
                fontWeight: "500",
                ":hover": { color: "primary.main" },
              }}
              variant="a"
            >
              {nav.label}
            </Typography>
          ))}
          <CustomButton
            onClick={() => navigate("/donate")}
            sx={{ display: { xs: "none", md: "flex" }, ml: 6 }}
          >
            Journey with us
          </CustomButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
